import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';
import useTable from '../components/useTable';
import { Dimmer } from '../components/spinner';
import axios from "axios";
import moment from 'moment';

const CatalogoOrdenPago3 = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));
    const norden = true;

    const btnAcepta = useRef();
    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]); 
    const [activo, setActivo] = useState(true);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    
    const headCells = [
        { label: '', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' }, 
        { label: 'COD ORDEN', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
        { label: 'COD COMP.', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
        { label: 'FECHA', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
        { label: 'PROVEEDOR', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
        { label: 'CONCEPTO', textAlign: 'center', backgroundColor: "rgb(5, 81, 130)", color: 'white' },
    ]

   
    
    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);
    
    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (norden ? x.numordenpago.includes(target.value) : x.idordenpago.includes(target.value)
                            || x.idcompromiso.includes(target.value)
                            || moment.utc(x.fecha).format('DD/MM/YYYY').includes(target.value)
                            || x.proveedor.toLowerCase().includes(target.value.toLowerCase())
                            || x.concepto.toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })
    }
    
    const seleccionarRegistros = () => {
        let endpoint = `${op.conexion}/api/administracion/seleccionardenpago3?idefiscal=${idefiscal}&ubic=${props.ubicacion}`;
        setActivate(true);
        setSelectedItems([]); 

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'
            },
        }).then(function (response) {
            if (response.status === 200) {
                setRecords(response.data)
            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        }).finally(() => {
            setActivate(false);
        })
    }
    
    const blanquear = () => {
        setActivate(false);
        setRecords([]);
        setSelectedItems([]);
        setFilterFn({ fn: items => { return items; } });
    }
    
    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }
    
    const aceptarAprobacines = () => {
      
        props.onHideAceptaCatalogo(selectedItems);
    };

  
    const handleCheckboxChange = (item) => (e) => {
        e.stopPropagation(); 
        
        if (e.target.checked) {
            if (!selectedItems.some(selected => selected.idordenpago === item.idordenpago)) {
                setSelectedItems([...selectedItems, item]);
            }
        } else {
            setSelectedItems(selectedItems.filter(selected => selected.idordenpago !== item.idordenpago));
        }
    };

    const handleRowClick = (item) => (e) => {
        e.preventDefault();
        const checkbox = e.target.querySelector('input[type="checkbox"]') || 
                        e.target.closest('tr').querySelector('input[type="checkbox"]');
        
        if (checkbox) {
            checkbox.checked = !checkbox.checked;
            const event = new Event('change', { bubbles: true });
            checkbox.dispatchEvent(event);
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedItems([...recordsAfterPagingAndSorting()]);
        } else {
            setSelectedItems([]);
        }
    };

    const isItemSelected = (item) => {
        return selectedItems.some(selected => selected.idordenpago === item.idordenpago);
    };

    React.useEffect(() => {
        setActivo(selectedItems.length === 0);
    }, [selectedItems]);

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                blanquear();
                seleccionarRegistros();
            }}
        >
            <Modal.Header className='header-azulGradiant'>
                <h3>
                    Incluir Documento.
                </h3>
                <a type='button' ref={btnCancela}
                    onClick={cancelar}>
                    salir<i className="fa fa-times"></i>
                </a>
            </Modal.Header>
            <Modal.Body >
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted />
                
                <div className="col-12 m-0">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="col-6 input-group input-group-sm">
                            <input type='text'
                                onChange={handleSearch} 
                                className="form-control rounded-pill search-input" 
                                placeholder="Buscar..."
                            />
                        </div>
                        <div className="text-muted">
                            {selectedItems.length} elemento(s) seleccionado(s)
                        </div>
                    </div>
                </div>
                
                <div className="col-12 m-0 p-0">
                    <TblContainer >
                       
                        <thead>
                            <tr>
                                <th style={{backgroundColor: "rgb(5, 81, 130)"}} className="text-center azulGradiant">
                                    <input 
                                        type="checkbox" 
                                        onChange={handleSelectAll}
                                        style={{backgroundColor: "rgb(5, 81, 130)"}}
                                        checked={selectedItems.length > 0 && selectedItems.length === recordsAfterPagingAndSorting().length}
                                        ref={input => {
                                            if (input) {
                                                input.indeterminate = selectedItems.length > 0 && 
                                                                     selectedItems.length < recordsAfterPagingAndSorting().length;
                                            }
                                        }}
                                    />
                                </th>
                                {headCells.slice(1).map((head, index) => (
                                    <th sty key={index} style={{ 
                                        textAlign: head.textAlign, 
                                        backgroundColor: "rgb(5, 81, 130)",
                                        color: head.color 
                                    }}>
                                        {head.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr 
                                        key={index} 
                                        style={{ 
                                            padding: "0", 
                                            cursor: 'pointer', 
                                            background: isItemSelected(item) ? "lightskyblue" : "white" 
                                        }} 
                                        //onClick={handleRowClick(item)}
                                    >
                                        <td className='py-2 text-center' onClick={(e) => e.stopPropagation()}>
                                            <input 
                                                type="checkbox" 
                                                checked={isItemSelected(item)}
                                                onChange={handleCheckboxChange(item)}
                                                onClick={(e) => e.stopPropagation()}
                                            />
                                        </td>
                                        {norden ? <td className='py-2 text-center'>{item.numordenpago}</td>
                                            : <td className='py-2 text-center'>{item.idordenpago}</td>
                                        }
                                        <td className='py-2 text-center'>{item.idcompromiso}</td>
                                        <td className='py-2 text-center'>{moment.utc(item.fecha).format('DD/MM/YYYY')}</td>
                                        <td className='py-2 text-center'>{item.proveedor}</td>
                                        <td className='py-2 text-center'>{item.concepto}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </TblContainer>
                    <TblPagination />
                </div>
            </Modal.Body>
            <Modal.Footer className='foooter-azulGradiant'>
                <button ref={btnAcepta}
                    className="btn btn-sm btnPrimary-azulGradiant rounded"
                    disabled={activo}
                    onClick={aceptarAprobacines}>
                    <i className="fas fa-check-circle"> Aceptar ({selectedItems.length})</i>
                </button>
                <button ref={btnCancela}
                    onClick={cancelar}
                    className="btn btn-sm  btnSecondary-azulGradiant rounded">
                    <i className="fas fa-window-close"> Cancelar</i>
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoOrdenPago3;